import React from "react";
import { Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const InvalidDiscount = () => {
  return <Typography sx={{color: "black"}} variant="body2"><TranslationContent contentID="invalidDiscountDesc" /></Typography>
}

export default InvalidDiscount;